module.exports = __webpack_public_path__ + "img/chip2.fb830d8f.png";